<template>
  <a-modal title="添加卡包"
           :open="modal"
           :destroy-on-close="true"
           cancel-text="关闭" @cancel="cancelCk">
    <a-form size="small"
            :label-col="{ span: 4 }"
            :wrapper-col="{ span: 20 }">
      <a-form-item label="卡ID" name="card">
        <a-input v-model:value="card"/>
      </a-form-item>

    </a-form>
    <template #footer>
      <a-button type="primary" @click="okCk">添加</a-button>
    </template>
  </a-modal>
</template>

<script setup>
import {ref} from 'vue'
import axios from '@/axios'
import {message} from 'ant-design-vue'

const emits = defineEmits(['refresh'])

const modal = ref(false)
const card = ref('')

let branchId

function okCk() {
  axios.post(`/branch/${branchId}/pack`, {
    card: card.value.replace('，', ',').split(','),
  }).then((res) => {
    if (res.code === 1) {
      message.success('操作成功')
      emits('refresh')
      modal.value = false
    }
  })
}

function openCk(id) {
  branchId = id
  modal.value = true
}

function cancelCk() {
  modal.value = false
}

defineExpose({openCk})
</script>